import styles from './ContactForm.module.scss';

import axios from 'axios';
import React from 'react';
import {
  Button,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Alert
} from 'reactstrap';

import { ScrollOverPack, TweenOne, FadeUp } from 'src/components/Animations';
import AnimatedCheckmark from 'src/components/AnimatedCheckmark';
import scroll from 'src/utils/scroll';

const SuccessMessage = (props) => (
  <div styleName='success-message'>
      <AnimatedCheckmark />
      <div styleName='text-container'>
          <div className='h3'>Thank you!</div>
          <div className='h4'>
              We&rsquo;ve received your request, and will get back to
              you as soon as possible.
          </div>
      </div>
  </div>
);

class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      isSuccess: false,
      error: null,
      formValues: {
        name: '',
        email: '',
        company: '',
        phone: '',
        subject: 'demo',
        description: ''
      }
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({isSubmitting: true});
    axios({
      url: `${process.env.API_URL}/api/contact-form`,
      method: 'post',
      data: this.state.formValues,
      mode: 'no-cors',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin'
    }).then(
      (response) => {
        this.setState({isSubmitting: false, error: null, isSuccess: true});

        // Scroll back to the top of the page after submission.
        setTimeout(() => window.scrollTo(0, 0), 1);
      },
      (response) => {
        this.setState({
          isSubmitting: false,
          error: ('There was an error submitting this form. ' +
                  'Please try again later.')
        });
      }
    );
  }

  handleChange(e) {
    const formValues = {...this.state.formValues, [e.target.name]: e.target.value};
    this.setState({formValues: formValues});
  }

  render() {
    // If the form was submitted successfully, just return the success
    // message. We still need to wrap it on a `contact-from` to make sure it has
    // the proper frame styling.
    if (this.state.isSuccess) {
      return (
        <div styleName='contact-form'>
            <SuccessMessage />
        </div>
      );
    }

    return (
      <ScrollOverPack appear={false}>
          <TweenOne component={Form}
                    key='contact-form'
                    styleName='contact-form'
                    onSubmit={this.handleSubmit}
                    {...FadeUp}>
              <Row>
                  <Col md='6' xs='12'>
                      <FormGroup>
                          <Label for='name'>Your name</Label>
                          <Input type='text'
                                 name='name'
                                 id='name'
                                 placeholder='John Smith'
                                 value={this.state.formValues.name}
                                 onChange={this.handleChange}
                                 required />
                      </FormGroup>
                  </Col>
                  <Col md='6' xs='12'>
                      <FormGroup>
                          <Label for='company'>Company name</Label>
                          <Input type='text'
                                 name='company'
                                 placeholder='Awesome Products Co'
                                 value={this.state.formValues.company}
                                 onChange={this.handleChange}
                                 required />
                      </FormGroup>
                  </Col>
              </Row>
              <Row>
                  <Col md='6' xs='12'>
                      <FormGroup>
                          <Label for='email'>Email address</Label>
                          <Input type='email'
                                 name='email'
                                 placeholder='john@company.com'
                                 value={this.state.formValues.email}
                                 onChange={this.handleChange}
                                 required />
                      </FormGroup>
                  </Col>
                  <Col md='6' xs='12'>
                      <FormGroup>
                          <Label for='phone'>Phone number</Label>
                          <Input type='text'
                                 name='phone'
                                 placeholder='(415) 123-4567'
                                 value={this.state.formValues.phone}
                                 onChange={this.handleChange}
                                 required />
                      </FormGroup>
                  </Col>
              </Row>
              <Row>
                  <Col xs='12'>
                      <FormGroup>
                          <Label for='subject'>Subject</Label>
                          <Input type='select'
                                 name='subject'
                                 id='subject'
                                 value={this.state.formValues.subject}
                                 onChange={this.handleChange}>
                              <option value='demo'>
                                  I'd like to schedule a demo!
                              </option>
                              <option value='questions'>
                                  I have some questions about your service
                              </option>
                              <option value='other'>
                                  Other
                              </option>
                          </Input>
                      </FormGroup>
                  </Col>
              </Row>
              <Row>
                  <Col xs='12'>
                      <FormGroup>
                          <Label for='description'>How can we help?</Label>
                          <Input type='textarea'
                                 name='description'
                                 id='description'
                                 placeholder="I'd like to see a demo!"
                                 value={this.state.formValues.description}
                                 onChange={this.handleChange}/>
                      </FormGroup>
                  </Col>
              </Row>
              {this.state.error && (
                <Alert key='alert' color='danger'>{this.state.error}</Alert>
              )}
              <Button color='primary' block disabled={this.state.isSubmitting}>
                  {this.state.isSubmitting ? 'Working...' : 'Submit'}
              </Button>
          </TweenOne>
      </ScrollOverPack>
    );
  }
}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/ContactForm.js